import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import { useIsLarge } from '../../../shared/theme';
import { propTypes } from '../common/prop-types';
import useFundsStateStore from '../common/funds-state-hook';
import Desktop from './card-components/desktop';
import MobileOrTablet from './card-components/mobile-or-tablet';

const Container = styled.div`
  margin-bottom: 8px;
`;

const getPerformanceAttribute = (fund, attribute) => _.find(_.get(fund, 'performance'), p => p.name === attribute);

export default function Card({ fund }) {
  const oneMonthReturnPercent = getPerformanceAttribute(fund, '1MonthReturnPercent');
  const oneYearReturnPercent = getPerformanceAttribute(fund, '1YearReturnPercent');
  const threeYearReturnPercent = getPerformanceAttribute(fund, '3YearReturnPercent');
  const fiveYearReturnPercent = getPerformanceAttribute(fund, '5YearReturnPercent');
  const returnSinceInception = getPerformanceAttribute(fund, 'returnSinceInceptionPercent');
  const currentView = useFundsStateStore(state => state.currentView) || 'summary';

  const props = {
    name: fund.name,
    fundType: fund.fundType,
    fundAssetClass: fund.fundAssetClass,
    inceptionDate: fund.inceptionDate,
    minimumInvestment: fund.minimumInvestment,
    managementFee: fund.managementFee,
    performanceFee: fund.performanceFee,
    isPerformanceFeeCharged: fund.isPerformanceFeeCharged,
    totalCostRatio: fund.totalCostRatio,
    financialYearEndFeesDate: fund.financialYearEndFeesDate,
    returnSinceInception: returnSinceInception.value,
    oneMonthReturnPercent: _.get(oneMonthReturnPercent, 'value'),
    oneYearReturnPercent: _.get(oneYearReturnPercent, 'value'),
    threeYearReturnPercent: _.get(threeYearReturnPercent, 'value'),
    fiveYearReturnPercent: _.get(fiveYearReturnPercent, 'value'),
    logoColor: fund.company.logoColor,
    logoPictureUrl: fund.company.logoPictureUrl,
    fundInvestorVehicleType: fund.fundInvestorVehicleType,
    wholesale: fund.wholesale,
    currentView,
  };

  const ComponentToShow = useIsLarge() ? Desktop : MobileOrTablet;

  useChangeAwareEffect(({ isMount }) => {
    isMount && recordStatisticsEvent({
      event: 'fund_search_fund_card_view',
      statisticable: 'fund',
      id: fund.id,
      page: window.location.pathname,
    });
  }, {});

  const showFund = e => {
    e && e.preventDefault();

    const { id, slug } = fund;
    const fundProfilePath = `/fund/${slug}`;

    recordStatisticsEvent({
      event: 'fund_search_fund_card_clicked',
      statisticable: 'fund',
      id,
      clicked_url: fundProfilePath,
      page: window.location.pathname,
    });

    window.location = fundProfilePath;
  };

  return (
    <Container onClick={showFund}>
      <ComponentToShow {...props} />
    </Container>
  );
}

Card.propTypes = propTypes;
